export default {
    title: 'Perfil',
    profile_information: 'Informações do Perfil',
    profile_info_description: 'Atualize as informações do seu perfil e endereço de e-mail.',
    photo: 'Foto',
    select_new_photo: 'Selecionar Nova Foto',
    remove_photo: 'Remover Foto',
    name: 'Nome',
    email: 'E-mail',
    language: 'Idioma',
    language_en: 'Inglês',
    language_pt: 'Português',
    language_hint: 'Usado na interface, e-mails e exibição de preços quando aplicável.',
    update_password: 'Atualizar Senha',
    password_description:
        'Certifique-se de que sua conta esteja usando uma senha longa e aleatória para permanecer segura.',
    current_password: 'Senha Atual',
    new_password: 'Nova Senha',
    confirm_password: 'Confirmar Senha',
    two_factor: 'Autenticação de Dois Fatores',
    two_factor_description:
        'Adicione segurança adicional à sua conta usando autenticação de dois fatores.',
    two_factor_not_enabled: 'Você não ativou a autenticação de dois fatores.',
    two_factor_enabled: 'Você ativou a autenticação de dois fatores.',
    two_factor_finish: 'Conclua a ativação da autenticação de dois fatores.',
    two_factor_finish_description:
        'Para concluir a ativação da autenticação de dois fatores, escaneie o código QR a seguir usando o aplicativo autenticador do seu telefone ou insira a chave de configuração e forneça o código OTP gerado.',
    two_factor_enabled_description:
        'A autenticação de dois fatores está ativada. Escaneie o código QR a seguir usando o aplicativo autenticador do seu telefone ou insira a chave de configuração.',
    browser_sessions: 'Sessões do Navegador',
    browser_sessions_description:
        'Gerencie e encerre suas sessões ativas em outros navegadores e dispositivos.',
    browser_sessions_info:
        'Se necessário, você pode encerrar todas as suas outras sessões do navegador em todos os seus dispositivos. Algumas de suas sessões recentes estão listadas abaixo; no entanto, esta lista pode não ser exaustiva. Se você acha que sua conta foi comprometida, você também deve atualizar sua senha.',
    unknown: 'Desconhecido',
    this_device: 'Este dispositivo',
    last_active: 'Última atividade',
    delete_account: 'Excluir Conta',
    delete_account_description: 'Exclua permanentemente sua conta.',
    delete_account_info:
        'Depois que sua conta for excluída, todos os seus recursos e dados serão permanentemente excluídos. Antes de excluir sua conta, faça o download de todos os dados ou informações que você deseja manter.',
    delete_account_confirm:
        'Tem certeza de que deseja excluir sua conta? Depois que sua conta for excluída, todos os seus recursos e dados serão permanentemente excluídos. Digite sua senha para confirmar que deseja excluir permanentemente sua conta.',
    save: 'Salvar',
    saved: 'Salvo.',
    enable: 'Ativar',
    disable: 'Desativar',
    confirm: 'Confirmar',
    setup_key: 'Chave de Configuração',
    code: 'Código',
    recovery_codes_description:
        'Armazene estes códigos de recuperação em um gerenciador de senhas seguro. Eles podem ser usados para recuperar o acesso à sua conta se seu dispositivo de autenticação de dois fatores for perdido.',
    regenerate_recovery_codes: 'Gerar Novos Códigos de Recuperação',
    show_recovery_codes: 'Mostrar Códigos de Recuperação',
    logout_sessions: 'Encerrar Outras Sessões do Navegador',
    logout_sessions_confirm:
        'Digite sua senha para confirmar que você deseja encerrar suas outras sessões do navegador em todos os seus dispositivos.',
    password: 'Senha',
    done: 'Concluído',
    cancel: 'Cancelar',
};
